import { isUrl } from '@v-c/utils'
import type { RouteRecordRaw } from 'vue-router'
import { omit } from 'lodash'

import type { MenuData, MenuDataItem } from '../../types/app'

import dynamicRoutes from '@/router/dynamic-routes'
import { ROOT_ROUTE_REDIRECT_PATH } from '@/router/constant.ts'
import { basicRouteMap } from '@/router/router-modules.ts'

let cache_key = 1

const getCacheKey = () => `Cache_Key_${cache_key++}`
/**
 * Tạo động menu và dữ liệu từ dynamic-routes trong dữ liệu phía trước
 */

export async function generateRoutes1(): Promise<RouteRecordRaw[]> {
  const auth = useAuth()

  function filterRoutesByAccess(routes: RouteRecordRaw[]) {
    return routes
      .filter(route => {
        return !route.meta?.uriRole || auth.hasUri(route.meta?.uriRole)
      })
      .map(route => {
        if (route.children?.length) {
          route.children = filterRoutesByAccess(route.children)
        }
        return route
      })
  }

  return filterRoutesByAccess(dynamicRoutes)
}
function renderTitle(route: RouteRecordRaw) {
  const { title } = route.meta || {}
  return title || ''
}
function formatMenu(route: RouteRecordRaw, path?: string) {
  return {
    id: route.meta?.id,
    parentId: route.meta?.parentId,
    title: () => renderTitle(route),
    icon: route.meta?.icon || '',
    path: path ?? route.path,
    hideInMenu: route.meta?.hideInMenu || false,
    parentKeys: route.meta?.parentKeys || [],
    hideInBreadcrumb: route.meta?.hideInBreadcrumb || false,
    hideChildrenInMenu: route.meta?.hideChildrenInMenu || false,
    locale: route.meta?.locale,
    keepAlive: route.meta?.keepAlive || false,
    name: route.name as string,
    url: route.meta?.url || '',
    target: route.meta?.target || '_blank',
  }
}
export async function generateRoutes() {
  const auth = useAuth()
  function filterRoutesByAccess(routes: RouteRecordRaw[]) {
    return routes
      .filter(route => {
        return !route.meta?.uri || auth.hasUri(route.meta?.uri)
      })
      .map(route => {
        if (route.children?.length) {
          route.children = filterRoutesByAccess(route.children)
        }
        return route
      })
  }
  const accessRoutes = filterRoutesByAccess(dynamicRoutes)
  const menuData = genRoutes(accessRoutes)

  return {
    menuData,
    routeData: dynamicRoutes,
  }
}

export function genRoutes(routes: RouteRecordRaw[], parent?: MenuDataItem) {
  const menuData: MenuData = []
  routes.forEach(route => {
    let path = route.path
    if (!path.startsWith('/') && !isUrl(path)) {
      // Kiểm tra xem hiện tại có bắt đầu bằng ký tự / hay không, nếu không thì có nghĩa là địa chỉ route hiện tại chưa phải là địa chỉ đầy đủ
      if (parent) path = `${parent.path}/${path}`
      else path = `/${path}`
    }
    if (!route.name) route.name = getCacheKey()
    const item: MenuDataItem = formatMenu(route, path)
    item.children = []
    if (route.children && route.children.length) item.children = genRoutes(route.children, item)
    if (item.children?.length === 0) delete item.children
    menuData.push(item)
  })
  return menuData
}

function checkComponent(component: RouteRecordRaw['component']) {
  for (const componentKey in basicRouteMap) {
    if (component === (basicRouteMap as any)[componentKey]) return undefined
  }
  return component
}

function flatRoutes(
  routes: RouteRecordRaw[],
  parentName?: string,
  parentComps: RouteRecordRaw['component'][] = []
) {
  const flatRouteData: RouteRecordRaw[] = []
  for (const route of routes) {
    const parentComponents = [...parentComps]
    const currentRoute = omit(route, ['children']) as RouteRecordRaw
    if (!currentRoute.meta) currentRoute.meta = {}
    if (parentName) currentRoute.meta.parentName = parentName
    if (parentComponents.length > 0) currentRoute.meta.parentComps = parentComponents
    currentRoute.meta.originPath = currentRoute.path
    flatRouteData.push(currentRoute)
    if (route.children && route.children.length) {
      const comp = checkComponent(route.component)
      if (comp) parentComponents.push(comp)
      flatRouteData.push(...flatRoutes(route.children, route.name as string, [...parentComponents]))
    }
  }
  return flatRouteData
}

export function generateFlatRoutes(routes: RouteRecordRaw[]) {
  const flatRoutesList = flatRoutes(routes)
  const parentRoute: RouteRecordRaw = {
    path: '/',
    redirect: ROOT_ROUTE_REDIRECT_PATH,
    name: 'ROOT_EMPTY_PATH',
    meta: {
      title: 'Trang chủ',
    },
    // component: getRouterModule('RouteView'),
    children: flatRoutesList,
  }
  return [parentRoute]
}
